import React from 'react';
import { INBOUND_TABS } from '@/utils/constants/inbound';
import { timeAgo } from '@/utils/ts/stringUtils';
import { INotification, IProfile } from '@Saral-Influencer-Marketing/saral-utils/src/models';

import RightArrow from '@/components/Icons/icons/RightArrow';

import AvatarComponent from '../AvatarComponent/AvatarComponent';
import ButtonComponent from '../ButtonComponent/ButtonComponent';

interface Props {
  notification: INotification;
  setShowNotificationDropdown: React.Dispatch<React.SetStateAction<boolean>>;
  markSingleNotificationAsSeen: () => void;
}

const ProductRequestsNotification = ({
  notification,
  setShowNotificationDropdown,
  markSingleNotificationAsSeen,
}: Props) => {
  const influencerData = notification?.influencerId as unknown as IProfile;
  return (
    <div className={`single-notification ${notification.seen && 'seen'}`}>
      <div className="unread-dot"></div>
      <AvatarComponent
        src={influencerData?.profile_pic || ''}
        alt={influencerData?.name || influencerData?.user_name || ''}
        size={36}
        style={{ marginLeft: '8px !important', marginRight: '0px !important' }}
      />

      <div className="text-div">
        <p className="text-sm font-normal text-default">{notification?.content?.description}</p>
        <div className="mt-2">
          <ButtonComponent
            variant="text-highlight"
            className="p-0"
            onClick={() => {
              markSingleNotificationAsSeen();
              setShowNotificationDropdown(false);
              window.location.href = `/dashboard/applications?tab=${INBOUND_TABS.PRODUCT_REQUESTS}`;
            }}
            rightIcon={<RightArrow color="var(--text-highlight)" />}>
            <span className="text-sm">Take action </span>
          </ButtonComponent>
        </div>
        <p className="timestamp pt-2">{timeAgo(notification?.createdAt.toString())}</p>
      </div>
    </div>
  );
};

export default ProductRequestsNotification;
